const data={"info":<>
<h1 style={{fontSize:"1.8rem",fontWeight:"600",textAlign:"left"}}>Shaurya Waedhan</h1> 
<div className="d-flex justify-content-center align-items-center pratha" style={{gap:"5rem"}} >

<div className="right-box-info">

<br/>
<ul className="pra-det">
    <li>Associate Treasurer, UPES-CSI</li>
    <li>
        Managing financial operations and budgets.
    </li>
    <li>
        Ensuring fiscal responsibility and transparency.
    </li>
</ul>
</div>
</div>
</>
}

export default data;
